import { environment } from 'src/environments/environment'

export default function getEnvVariable(variable: string): string | object | undefined {
    const env = window['__env'] || environment
    if (env && Object.prototype.hasOwnProperty.call(env, variable)) {
        return env[variable]
    }
    return undefined
}
